const voiceSpeak = (text) => {
  if (window.VIZIO && text) {
    window.VIZIO.Chromevox.play(text);
  } else {
    console.log(text);
  }
}

export default voiceSpeak;